import {
  Backdrop,
  Box,
  Button,
  CloseReason,
  OpenReason,
  SpeedDialAction,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import useLanguages from "../../../explorer/hooks/useLanguages";
import { useUserInfo } from "../../../explorer/hooks/useUserInfo";
import AppIconsOrderOffer from "../AppIcons/AppIconsOrderOffer";
import {
  SpeedDialOperationStyled,
  TextButtonOperationStyled,
  useClasses,
} from "./BasketOperations.style";
import { BasketWarrantyDialog } from "./BasketWarrantyDialog";
import { BasketOfferOrderDialog } from "./OrderOffer/BasketOfferOrderDialog";
import {
  BasketDetail,
  BasketOperationsPermissions,
} from "../../../explorer/types/Basket/BasketDetail";
import { useTableLayoutClasses } from "../PartsList/TableLayout/TableLayout.style";
import useCurrentSite from "../../hook/useCurrentSite";
import CommonDialog from "../CommonDialog/CommonDialog";
import FileCopyIcon from "@mui/icons-material/FileCopyOutlined";
import { AppIconsOffer, AppIconsOrder, AppIconsOrderTypeService } from "../AppIcons";

type BasketDetailsOperationsProps = {
  currency?: string;
  showDiscount?: boolean;
  //hasErrors: boolean;
  items: any;
  prices: any;
  operationsPermissions?: BasketOperationsPermissions;
};

export const BasketOperations: React.FC<BasketDetailsOperationsProps> = ({
  currency,
  showDiscount,
  //hasErrors,
  items,
  prices,
  operationsPermissions,
}) => {
  const [actionLeft, setActionLeft] = useState(0);
  const [actionBottom, setActionBottom] = useState(0);

  var speedDialRef: any = useRef(null);

  const [open, setOpen] = useState(false);
  const [actionOver, setActionOver] = useState(false);

  // const [hasErrorsState, setHasErrorsState] = useState(hasErrors);

  const { t } = useTranslation();
  const [currentSite] = useCurrentSite();
  const TableClasses = useTableLayoutClasses();

  const [alertDialogOpen, setAlertDialogOpen] = useState<boolean>(false);
  const [alertDialogMessages, setAlertDialogMessages] = useState<string[]>([]);

  // useEffect(() => {
  //     setHasErrorsState(hasErrors);
  // }, [hasErrors]);

  const hidden =
    currentSite?.permissions?.canSubmitWarrantyOrder === false &&
    currentSite?.permissions?.canRequestAnOffer === false &&
    currentSite?.permissions?.canSubmitAnOrder === false;

  const setActionPositionDesktop = function () {
    if (speedDialRef && speedDialRef.current) {
      const boundingBox = speedDialRef.current.getBoundingClientRect();
      setActionBottom(window.innerHeight - boundingBox.bottom + 60);
      setActionLeft(boundingBox.left + 1125);
    }
  };

  useEffect(() => {
    setActionPositionDesktop();
    window.addEventListener("resize", setActionPositionDesktop);
    return () => window.removeEventListener("resize", setActionPositionDesktop);
  }, []);

  const handleClick = () => {
    setActionPositionDesktop();
    setOpen(!open);
  };

  const handleClose = (
    event: React.SyntheticEvent<{}>,
    reason: CloseReason
  ) => {
    if (reason == "blur" || reason == "escapeKeyDown" || reason == "toggle")
      setOpen(false);
  };

  const [warrantyDialogOpen, setWarrantyDialogOpen] = useState<boolean>(false);
  const handleClickWarranty = (event: any) => {
    if (operationsPermissions?.warrantyEnabled === false) {
      if (operationsPermissions?.warrantyDisabledMessages && operationsPermissions?.warrantyDisabledMessages?.length > 0) {
        setAlertDialogOpen(true);
        setAlertDialogMessages(operationsPermissions?.warrantyDisabledMessages ?? []);
      }
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
    setWarrantyDialogOpen(true);
  };
  const handleCloseWarrantyDialog = () => {
    setWarrantyDialogOpen(false);
  };

  const [orderDialogOpen, setOrderDialogOpen] = useState<boolean>(false);

  const handleClickOrder = (event: any) => {
    if (operationsPermissions?.orderEnabled === false) {
      if (
        operationsPermissions?.orderDisabledMessages &&
        operationsPermissions?.orderDisabledMessages?.length > 0
      ) {
        setAlertDialogOpen(true);
        setAlertDialogMessages(
          operationsPermissions?.orderDisabledMessages ?? []
        );
      }
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
    setOrderDialogOpen(true);
  };
  const handleCloseOrderDialog = () => {
    setOrderDialogOpen(false);
  };

  const [offerDialogOpen, setOfferDialogOpen] = useState<boolean>(false);

  const handleClickOffer = (event: any) => {
    if (operationsPermissions?.offerEnabled === false) {
        if (operationsPermissions?.offerDisabledMessages && operationsPermissions?.offerDisabledMessages?.length > 0) {
          setAlertDialogOpen(true);
          setAlertDialogMessages(operationsPermissions?.offerDisabledMessages ?? []);
        }
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
    setOfferDialogOpen(true);
  };

  const handleCloseOfferDialog = () => {
    setOfferDialogOpen(false);
  };

  // const showBasketOperationButton = () => {
  //     return (
  //         userInfo.userPermissions?.canRequestAnOffer &&
  //         userInfo.userPermissions?.canSubmitAnOrder &&
  //         userInfo.userPermissions?.canSubmitWarrantyOrder
  //     );
  // };
  const classes = useClasses({
      open: open,
      actionOver: actionOver,
  });

  const handleCloseAlertDialog = () => {
    setAlertDialogOpen(false);
    setAlertDialogMessages([]);
  };

  if (!operationsPermissions) return <></>;

  return (
      <>
          <Backdrop open={open} style={{ zIndex: 1299, opacity: 0.7 }} />
          <SpeedDialOperationStyled
              hidden={hidden}
              icon={
                  <>
                      <AppIconsOrderOffer />
                      <TextButtonOperationStyled>
                          {t("basket.validate")}
                      </TextButtonOperationStyled>
                  </>
              }
              onClose={handleClose}
              onOpen={undefined}
              open={open}
              onClick={handleClick}
              ref={speedDialRef}
              FabProps={{ variant: "extended" }}
              sx={[classes.speedDialStyle, TableClasses.hideOnPrint]}
              ariaLabel={"Basket SpeedDial"}
              actionleft={0}
              actionbottom={0}
          >
              {currentSite?.permissions?.canSubmitAnOrder && (
                  <SpeedDialAction
                      key={"1"}
                      className="circle"
                      icon={<AppIconsOrder />}
                      tooltipTitle={
                          <Button
                              sx={classes.speedDialTooltipButtonWhite}
                              //disabled={operationsPermissions.orderEnabled === false}
                              className={
                                  operationsPermissions.orderEnabled === false
                                      ? "alert"
                                      : ""
                              }
                          >
                              <Box sx={classes.speedDialTooltip}>
                                  {t("orderoffer.order")}
                              </Box>
                          </Button>
                      }
                      tooltipOpen
                      onClick={handleClickOrder}
                      sx={classes.speedDialTooltip}
                  />
              )}
              {currentSite?.permissions?.canRequestAnOffer && (
                  <SpeedDialAction
                      key={"2"}
                      className="circle"
                      icon={<AppIconsOffer />}
                      tooltipTitle={
                          <Button
                              sx={classes.speedDialTooltipButtonWhite}
                              //disabled={operationsPermissions.offerEnabled === false}
                              className={
                                  operationsPermissions.offerEnabled === false
                                      ? "alert"
                                      : ""
                              }
                          >
                              <Box sx={classes.speedDialTooltip}>
                                  {t("orderoffer.offer")}
                              </Box>
                          </Button>
                      }
                      tooltipOpen
                      onClick={handleClickOffer}
                      sx={classes.speedDialTooltip}
                  />
              )}
              {currentSite?.permissions?.canSubmitWarrantyOrder && (
                  <SpeedDialAction
                      key={"3"}
                      className="circle"
                      icon={<AppIconsOrderTypeService />}
                      tooltipTitle={
                          <Button
                              onMouseOver={() => {
                                  setActionOver(true);
                              }}
                              onMouseOut={() => {
                                  setActionOver(false);
                              }}
                              sx={classes.speedDialTooltipButtonWhite}
                              // disabled={operationsPermissions.warrantyEnabled === false}
                              className={
                                  operationsPermissions.warrantyEnabled ===
                                  false
                                      ? "alert"
                                      : ""
                              }
                          >
                              <Box sx={classes.speedDialTooltip}>
                                  {t("orderoffer.warranty")}
                              </Box>
                          </Button>
                      }
                      tooltipOpen
                      onClick={handleClickWarranty}
                      onMouseOver={() => {
                          setActionOver(true);
                      }}
                      onMouseOut={() => {
                          setActionOver(false);
                      }}
                      sx={classes.speedDialTooltip}
                  />
              )}
          </SpeedDialOperationStyled>
          <BasketWarrantyDialog
              open={warrantyDialogOpen}
              onClose={handleCloseWarrantyDialog}
          />

          <BasketOfferOrderDialog
              open={offerDialogOpen}
              onClose={handleCloseOfferDialog}
              prices={prices}
              items={items}
              currency={currency}
              showDiscount={showDiscount}
              typeSubmit={"OFFER"}
          />

          <BasketOfferOrderDialog
              open={orderDialogOpen}
              onClose={handleCloseOrderDialog}
              prices={prices}
              items={items}
              currency={currency}
              showDiscount={showDiscount}
              typeSubmit={"ORDER"}
          />
          <CommonDialog
              open={alertDialogOpen}
              dialogTitleLabel="alert.title.warning"
              useDenyBtn={false}
              useConfirmBtn={false}
              closeDialog={handleCloseAlertDialog}
              children={
                  <>
                      {alertDialogMessages?.map((message) => (
                          <div key={message}>
                              {t("orderoffer.alert." + message)}
                          </div>
                      ))}
                  </>
              }
          ></CommonDialog>
      </>
  );
};
